<div class="overlay__content"></div>
<div class="overlay__spinner">
  <div class="overlay__spinner-light"></div>
  <div class="overlay__spinner-dark"></div>
</div>
